import { Action, createReducer, on } from "@ngrx/store";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import * as GradeActionTypes from "../../actions/grades/grades.actions";

export interface GradeState {
  grades: any[];
  gradesList: any[];
  gradesExcel: any[];
  gradesTableConfig: ColumnSorterInfo[];
  grade: any;
  created: boolean;
  isLoading: boolean;
  totalGrades: number;
}

export const initialState: GradeState = {
  grades: null,
  gradesTableConfig: null,
  created: false,
  gradesList: null,
  gradesExcel: null,
  totalGrades: null,
  grade: null,
  isLoading: false,
};

const gradeReducer = createReducer(
  initialState,
  on(GradeActionTypes.resetGradesState, () => initialState),
  on(GradeActionTypes.resetGrade, (state) => {
    return {
      ...state,
      grade: null,
      error: null,
    };
  }),
  on(
    GradeActionTypes.getGradeList,
    (state, { pageReq }) =>
      ({
        ...state,
        error: null,
        pageReq: pageReq,
      } as GradeState)
  ),
  on(GradeActionTypes.loadGradeList, (state, { response }) => {
    return {
      ...state,
      grades: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(
    GradeActionTypes.getGradesList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as GradeState)
  ),
  on(GradeActionTypes.loadGradeList, (state, { response }) => {
    return {
      ...state,
      gradesList: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      totalGrades: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
      isLoading: false,
      error: null,
    };
  }),
  on(
    GradeActionTypes.getExcelGradesList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as GradeState)
  ),
  on(GradeActionTypes.loadExcelGradesList, (state, { response }) => {
    return {
      ...state,
      gradesExcel: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(
    GradeActionTypes.getGrade,
    (state, { code }) =>
      ({
        ...state,
        error: null,
        code: code,
        created: false,
        isLoading: true,
      } as GradeState)
  ),
  on(GradeActionTypes.loadGrade, (state, { response }) => {
    return {
      ...state,
      grade: (response as any).result ? (response as any).result : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(GradeActionTypes.createGrade, (state, { grade }) => ({
    ...state,
    grade: grade?.result || null,
    error: null,
  })),
  on(GradeActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(GradeActionTypes.updateGrade, (state, { grade }) => ({
    ...state,
    grade: grade?.result || null,
    error: null,
  })),
  on(GradeActionTypes.getGradesTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(GradeActionTypes.loadGradesTableConfig, (state, { response }) => {
    return {
      ...state,
      gradesTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(GradeActionTypes.saveGradesTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(GradeActionTypes.gradeLoadEnd, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: GradeState | undefined, action: Action) {
  return gradeReducer(state, action);
}
